import {
    Cluster,
    ClusterStats,
    Marker,
    Renderer,
} from '@twitchaxorg/markerclusterer';
import { getClusterMarker, getMarkerElement } from './helpers/utils';

import { getCategoryClusterIcon } from './helpers/markers';
import pointCache from './helpers/state/point-cache';
import topicData from './helpers/state/topic-data';

export class ProxiClusterRenderer implements Renderer {
    render(cluster: Cluster, stats: ClusterStats): Marker {
        const categories = pointCache.topic?.categories ?? [];
        const topCategoryIcons = categories.slice(0, Math.min(5, categories.length)).map(c => c.icon);
        return getClusterMarker(undefined, cluster.position, topCategoryIcons, cluster.count, cluster.count + 1000, pointCache.advancedMarkers);
    }
}

export class ProxiClusterRendererSimple implements Renderer {
    render({ count, position }: Cluster, stats: ClusterStats): Marker {

        const categories = Array.from(topicData.categoryIconDataUrls.entries()).map(e => e[1]);
        const limitedCategoryIcons = categories.slice(0, Math.min(5, categories.length));
        
        const size = (topicData.topic?.icon_size ?? 40) * 1.25;
        const icon = getCategoryClusterIcon(topicData.topic?.cluster_accent_color ?? topicData.backgroundColor, topicData.textColor, count, size, limitedCategoryIcons);

        return getMarkerElement(undefined, position, icon, 1000 + count, pointCache.advancedMarkers, undefined, undefined, undefined);
    }
}